// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function serialize(obj: { [key: string]: any }, prefix?: string): string {
  const str: string[] = []
  for (const p in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, p)) {
      const k = prefix ? prefix + '[' + p + ']' : p
      const v = obj[p]

      str.push(
        v !== null && typeof v === 'object'
          ? serialize(v, k)
          : `${encodeURIComponent(k)}=${encodeURIComponent(v)}`,
      )
    }
  }

  return str.join('&')
}
